<template>
  <b-modal v-model="displayStatus">
    <div slot="modal-title">
      {{ $t('message.booking.switch_professional_modal.title') }}
    </div>
    <section class="text-center">
      <div>
        <img src="/static/img/ic_announcement.svg" width="104">
      </div>
      <div class="mt-3">
        <h3>{{ $t('message.booking.switch_professional_modal.subtitle1') }}</h3>
      </div>
    </section>

    <section>
      <div class="mb-2">
        <img src="/static/img/ic_switch_professional_issue01.svg">
        {{ $t('message.booking.switch_professional_modal.issue1') }}
      </div>
      <div class="mb-2">
        <img src="/static/img/ic_switch_professional_issue02.svg">
        {{ $t('message.booking.switch_professional_modal.issue2') }}
      </div>
      <div class="mb-2">
        <img src="/static/img/ic_switch_professional_issue03.svg">
        {{ $t('message.booking.switch_professional_modal.issue3') }}
      </div>
      <div class="mb-2">
        <img src="/static/img/ic_switch_professional_issue04.svg">
        {{ $t('message.booking.switch_professional_modal.issue4') }}
      </div>
    </section>

    <section class="text-center">
      <div class="my-3">
        <h3><span class="text-info">BeNeat</span> {{ $t('message.booking.switch_professional_modal.subtitle2') }}</h3>
      </div>
      <div class="px-4 py-3 rounded bg-gray">
        <div class="font-weight-light">{{ $t('message.booking.switch_professional_modal.subtitle2_content1') }}</div>
        <div class="text-info font-weight-normal">{{ $t('message.booking.switch_professional_modal.subtitle2_content2') }}</div>
      </div>
    </section>
    
    <template #modal-footer>
      <div class="w-100">
        <b-button variant="info" class="float-right" @click="displayStatus=false">
          {{ $t('message.booking.switch_professional_modal.confirm_button') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  export default {
    data () {
      return {
        displayStatus: false
      }
    },
    methods: {
      showModal (status) {
        this.displayStatus = status
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/order/components/SelectPreBookingProfessionalInfoModal.vue